module.exports = __webpack_public_path__ + "img/body-1.db1ca8d0.png";